import React from 'react';

import { CaseStudies, Heading } from '../../../components';



const CaseSection = () => {
  return (

    <section>

      {/* Section heading */}
      <Heading title={'Case Studies'} subTitle={'Our Success Stories'} />

      {/* Case Studies Component */}
      <CaseStudies />

    </section>

  );
}

export default CaseSection;